/**
 * Les faits d'une commande, dans une fiche détaillée.
 *
 * Les trois fiches — admin, confirmation, marchand — affichaient les mêmes
 * données dans trois mises en page différentes, à base d'encadrés bordés qui
 * repoussaient les actions hors de l'écran. Elles partagent désormais ce bloc :
 * le montant en gros, parce que c'est le chiffre qu'on vérifie, et le reste en
 * lignes simples.
 */
export default function OrderFacts({ amount, lines = [], style }) {
  return (
    <div style={{ marginBottom: '14px', ...style }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px', marginBottom: '4px' }}>
        <span style={{ fontFamily: 'Alan Sans, sans-serif', fontSize: '26px', fontWeight: 800, color: '#173b78', lineHeight: 1 }}>
          {amount ? Number(amount).toLocaleString('fr-FR') : '—'}
        </span>
        {amount ? <span style={{ fontSize: '13px', fontWeight: 700, color: '#94a3b8' }}>FCFA</span> : null}
      </div>

      {lines.filter(Boolean).map(({ label, value }) => (
        <div key={label} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderTop: '1px solid #f1f5f9' }}>
          <span style={{ fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.6px', width: '92px', flexShrink: 0, paddingTop: '2px' }}>
            {label}
          </span>
          <span style={{ fontSize: '13px', fontWeight: 600, color: '#1e293b', flex: 1, minWidth: 0 }}>
            {value}
          </span>
        </div>
      ))}
    </div>
  );
}

/** Produit et quantité tiennent sur une ligne — la quantité vaut 1 presque partout. */
export function productLine(order) {
  if (!order?.product_name) return null;
  const qty = Number(order.quantity) || 1;
  return { label: 'Produit', value: `${order.product_name}${qty > 1 ? ` ×${qty}` : ''}` };
}
